import {map} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Apollo} from "apollo-angular";
import {
  ItsmPurchaseOrderModel,
  PurchaseOrderModel,
  purchaseOrderModelListFactory,
  itsmPurchaseOrderModelListFactory, PurchaseOrderStatusGqlModel,
} from "./purchase-order.model";
import {Observable, Subject} from "rxjs";

@Injectable()
export class PurchaseOrderService {
  private url: string = "/api/purchase-orders";
  public monthlyPOChange: Subject<boolean> = new Subject<boolean>();

  constructor(public http: HttpClient, private apollo: Apollo) {
  }

  getPurchaseOrders(projectId, {isInItsm}):
    Promise<{itsmPurchaseOrders: ItsmPurchaseOrderModel[], tmcPurchaseOrders: PurchaseOrderModel[]}> {
    const params = {
      isInItsm,
      projectId: projectId ? `${projectId}` : "",
    };
    return this.http.get(this.url, {params})
      .pipe(map(result => ({
        itsmPurchaseOrders: itsmPurchaseOrderModelListFactory(result["itsmPurchaseOrders"]),
        tmcPurchaseOrders: purchaseOrderModelListFactory(result["tmcPurchaseOrders"]),
      })))
      .toPromise();
  }

  savePurchaseOrders(purchaseOrders: any, projectId): Promise<any> {
    return this.http.post(this.url, {purchaseOrders, projectId}).toPromise();
  }

  getPurchaseOrdersStatus(projectId, transactionId): Observable<PurchaseOrderStatusGqlModel> {
    const query = PurchaseOrderStatusGqlModel.query;
    const variables = PurchaseOrderStatusGqlModel.variables(projectId, transactionId);

    return this.apollo.subscribe({query, variables, fetchPolicy: "no-cache"})
      .pipe(PurchaseOrderStatusGqlModel.mapper);
  }
}
